import React from "react";
import ServiceDetailPage from "./ServiceDetailPage";

export default function Network() {
  return (
    <ServiceDetailPage
      pageClassName="network"
      heroClassName="network-hero"
      title="Network & Connectivity"
      subtitle="Seamless IoT integration, fiber deployments, and enterprise networking with Wi‑Fi 6/6E, SD‑WAN, and zero‑trust security."
      heroPrimaryLabel="Explore Overview"
      heroSecondaryLabel="Plan a Network Assessment"
      overviewLead="We design scalable, resilient networks—from campus Wi‑Fi to SD‑WAN—built on best practices for performance, observability, and security."
      overviewBullets={[
        "High‑density Wi‑Fi for offices, campuses, and venues",
        "Fiber and structured cabling with certified testing",
        "SD‑WAN with application‑aware routing and visibility",
        "Zero‑trust segmentation and next‑gen firewalls",
        "24/7 monitoring and proactive health checks",
      ]}
      features={[
        { title: "Enterprise Wi‑Fi 6/6E", description: "Seamless roaming, RF optimization, and guest access portals." },
        { title: "Fiber & Cabling", description: "Backbone fiber, copper, racks, and certified test reports." },
        { title: "SD‑WAN", description: "Intelligent path selection and centralized management." },
        { title: "Network Security", description: "NGFW, IPS, content filtering, and zero‑trust segmentation." },
        { title: "Observability", description: "Telemetry, NetFlow, and alerting for rapid troubleshooting." },
        { title: "Remote Access", description: "Secure VPN and SSO integration for hybrid teams." },
      ]}
      solutionsHeading="Tailored Solutions"
      solutions={[
        {
          title: "Campus Networks",
          description: "High‑density Wi‑Fi, smart RF planning, and seamless roaming.",
          items: ["Multi‑building fiber backbone", "Guest and BYOD segmentation", "Self‑healing mesh for critical areas"],
        },
        {
          title: "Industrial IoT",
          description: "Rugged switches, ring topologies, and edge security.",
          items: ["Harsh environment enclosures", "Deterministic latency", "OT/IT secure segmentation"],
        },
        {
          title: "Branch Connectivity",
          description: "SD‑WAN with LTE/5G failover to keep sites always on.",
          items: ["App‑aware routing", "Centralized policy", "Zero‑touch provisioning"],
        },
        {
          title: "Data Center",
          description: "Leaf‑spine designs with VXLAN/EVPN and micro‑segmentation.",
          items: ["High throughput fabrics", "Automation & IaC", "Security at every tier"],
        },
      ]}
      pricingLead="Engagements are scoped to your sites, user density, and SLAs."
      pricingTiers={[
        {
          title: "Starter",
          description: "Small office or single site deployments.",
          items: ["Wi‑Fi + firewall setup", "Basic monitoring", "Email support"],
        },
        {
          title: "Business",
          description: "Multi‑site SD‑WAN and centralized control.",
          items: ["Advanced policies", "Proactive health checks", "Priority support"],
          featured: true,
        },
        {
          title: "Enterprise",
          description: "Campus/DC networks with automation and SSO.",
          items: ["Custom architectures", "Observability stack", "24/7 on‑call"],
        },
      ]}
      contactTitle="Speak with a Network Engineer"
      contactLead="Share your goals—we’ll blueprint a resilient, secure network."
    />
  );
}